import useAppStore from "@/context/store";
import { Dropdown } from "antd";
import classNames from "classnames";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { When } from "react-if";
import BoardModal from "../BoardModal";
import HBIcon from "../HBIcon";
import HBMessage from "../HBMessage";
import { useLogin } from "../LoginModal";
import { PinUploaderModal } from "../PinCreator";
import PinSuccessMessage from "../PinSuccessMessage";
import styles from "./index.module.less";

// 创建画板，上传采集入口
export default function CreateEntry() {
  const { user, config } = useAppStore(({ user, config }) => ({
    user,
    config,
  }));
  const router = useRouter();
  const { login } = useLogin();

  const onCreateBoard = useCallback(async () => {
    if (!user) {
      const result = await login();
      if (!result) {
        return;
      }
    }

    BoardModal.open({
      name: "boardModal",
      onOk: (board) => {
        router.push(`/boards/${board.board_id}`);
      },
    });
  }, [login, router, user]);

  const onCreatePin = useCallback(async () => {
    let userInfo = user;
    if (!userInfo) {
      userInfo = await login();
      if (!userInfo) {
        return;
      }
    }

    if (!userInfo?.bindings?.wechat && !userInfo?.tel) {
      HBMessage.error(
        "根据《互联网用户账号信息管理规定》，上传采集需绑定微信或手机号"
      );
      router.push("/settings?tab=account");
      return;
    }

    PinUploaderModal.open({
      name: "pinUploaderModal",
      onOk: (board, list, hasAiImg) => {
        PinSuccessMessage.open({
          pin: { ...board?.pins?.shift(), board },
          extra: hasAiImg
            ? { link: "/ai", subtitle: "AI作品已发布到", title: "AI圈" }
            : null,
          hideButton: true,
        });
      },
    });
  }, [login, user, router]);

  return (
    <Dropdown
      className={styles.avatar}
      getPopupContainer={(triggerNode) => triggerNode}
      // destroyPopupOnHide
      // visible={true}
      overlay={
        <div className={classNames(styles.dropDown, styles.entryList)}>
          <div
            className={styles.entryListItem}
            onClick={onCreatePin}
            data-gd-click="button_click"
            data-button-name="上传采集"
            data-resource-title="上传采集"
            data-gd-expose="resource_loc_expose"
            data-resource-type="弹窗"
          >
            <HBIcon type="upload" />
            <span>上传采集</span>
            <span className={styles.shortcuts}>N</span>
          </div>
          <div
            className={styles.entryListItem}
            onClick={onCreateBoard}
            data-gd-click="button_click"
            data-button-name="创建画板"
          >
            <HBIcon type="dashboard" />
            <span>创建画板</span>
            <span className={styles.shortcuts}>C</span>
          </div>
          <When condition={config?.gaodingProGuide}>
            <a
              className={styles.entryListItem}
              target="_blank"
              href={config?.gaodingProUrl}
              rel="noreferrer"
              data-gd-click="button_click"
              data-gd-expose="resource_loc_expose"
              data-button-name={`去${config?.gaodingProText}上传`}
              data-resource-id={0}
              data-resource-title={`去${config?.gaodingProText}上传`}
              data-resource-type="文字链接"
            >
              <HBIcon type="ic_pro" />
              <span>去{config?.gaodingProText}上传</span>
            </a>
          </When>
          <Link
            href="/about/goodies"
            data-gd-click="button_click"
            data-button-name="浏览器插件"
          >
            <a className={classNames(styles.entryListItem, styles.pluginItem)}>
              <HBIcon type="icon1" />
              <span>浏览器插件</span>
            </a>
          </Link>
        </div>
      }
      placement="bottomRight"
    >
      <div className={styles.createEntry}>
        <HBIcon type="add" />
      </div>
    </Dropdown>
  );
}
